module.exports = __webpack_public_path__ + "edc0e7141a6f565a5c9cae93aba2816f.pdf";